import React from "react";
import Accordion from "react-bootstrap/Accordion";
import Button from "react-bootstrap/Button";
import ManageCustomer from "./manageCustomer";
import CreateCustomer from "./createCustomer";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

export default ({
  customers,
  mode,
  handleModeChange,
  updateCustomerToDB,
  createCustomerToDB,
  deleteCustomerToDB
}) => (
    <div >
      <div style={{ display: "flex", marginBottom: "15px"}}>
        {mode === "view" ? (
          <Button
            style={{marginRight: "5px"}}
            variant="secondary"
            onClick={() => handleModeChange("edit")}
          >
            Change to edit Mode
          </Button>
        ) : (
          <Button
            style={{marginRight: "5px"}}
            variant="secondary"
            onClick={() => handleModeChange("view")}
          >
            Change to view mode
          </Button>
        )}
        <div>
          <CreateCustomer
              createCustomerToDB={createCustomerToDB}
          />
        </div>
      </div>

      <div>
        <Accordion>
          {customers &&
            customers.map((customer, i) => (
              <div key={i} style={{marginBottom: "5px"}}>
                {mode === "edit" ? (
                  <Accordion.Item eventKey={`${i}`}  >
                    <Accordion.Header>
                      <Row style={{ width: '100%' }}>
                        <Col xs={6}>
                          <span>{customer.name}</span>
                        </Col>
                        <Col xs={6} className="text-end">
                          <span className="text-muted">id: {customer.id}</span>
                        </Col>
                      </Row>
                    </Accordion.Header>
                    <Accordion.Body>
                      <ManageCustomer
                        name={customer.name}
                        mode="edit"
                        id={customer.id}
                        sfdc_ids={customer.sfdc_ids}
                        updateCustomerToDB={updateCustomerToDB}
                        deleteCustomerToDB={deleteCustomerToDB}
                      />
                    </Accordion.Body>
                  </Accordion.Item>
                ) : (
                  <Accordion.Item eventKey={`${i}`}  >
                    <Accordion.Header>
                      <Row style={{ width: '100%' }}>
                        <Col xs={6}>
                          <span>{customer.name}</span>
                        </Col>
                        <Col xs={6} className="text-end">
                          <span className="text-muted">id: {customer.id}</span>
                        </Col>
                      </Row>
                    </Accordion.Header>
                    <Accordion.Body>
                    <ManageCustomer
                        name={customer.name}
                        mode="view"
                        id={customer.id}
                        sfdc_ids={customer.sfdc_ids}
                        updateCustomerToDB={updateCustomerToDB}
                        deleteCustomerToDB={deleteCustomerToDB}
                      />
                    </Accordion.Body>
                  </Accordion.Item>
                )}
              </div>
            ))}
        </Accordion>
      </div>
    </div>
);
 